import ReactDOM from 'react-dom/client'

import './i18n'

import { LOCAL_STORAGE_API_KEY } from './constants/storage'
import { loadAppVersion } from './utils/appVersion'
import { getEnvBackendHost, isDevelopmentEnvironment } from './utils/common'
import { setStorageItem } from './utils/storage'
import App from './App'

import './index.css'
import './styles/animations.css'

// `BACKEND=host` / `yarn start-local` preset the API origin; the env value wins
// over a console-set `bs_api` on every start, hence the log.
const envBackendHost = getEnvBackendHost()

if (isDevelopmentEnvironment() && envBackendHost) {
  const envBackendOrigin = `//${envBackendHost}/`

  setStorageItem(LOCAL_STORAGE_API_KEY, envBackendOrigin)

  console.info(`bs_api set from BACKEND env: ${envBackendOrigin}`)
}

// Not every screen renders `PageFooter` (worker app, raw thread views,
// doc-flows, auth pages), so the version for the `X-App-Version` header must
// be loaded on app start, not only from the footer.
loadAppVersion()

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(<App />)
